import TreatmentIcon from 'src/components/svg/menu/TreatmentIcon';
import MessageIcon from 'src/components/svg/menu/MessageIcon';
import AppointmentIcon from 'src/components/svg/menu/AppointmentIcon';
import DiscoveryIcon from 'src/components/svg/menu/DiscoveryIcon';
import ChartIcon from 'src/components/svg/menu/ChartIcon';
import MenuPatientIcon from './MenuPatientIcon';
import ScheduleIcon from './ScheduleIcon';
import JourneyIcon from './JourneyIcon';
import DoctorIcon from './DoctorIcon';
import InvoiceIcon from './InvoiceIcon';
import ManagerIcon from './ManagerIcon';
import AiIcon from "./AiIcon";

const index = {
  'treatment-icon': TreatmentIcon,
  'message-icon': MessageIcon,
  'appointment-icon': AppointmentIcon,
  'discovery-icon': DiscoveryIcon,
  'chart-icon': ChartIcon,
  'menu-patient-icon': MenuPatientIcon,
  'schedule-icon': ScheduleIcon,
  'journey-icon': JourneyIcon,
  'doctor-icon': DoctorIcon,
  'invoice-icon': InvoiceIcon,
  'manager-icon': ManagerIcon,
  'ai-icon': AiIcon,
};

export default index;
